import transform from '@/services/baux/echeancierContrat/echeancierContratTableDataTransformer';
import HTTP from '@/api/HTTP';

const URL_BASE = 'gescom/EcheancierContrat/';

export async function getAll(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetEcheancesAPayerAsync', inputServer);
  return response;
}

export async function echeancierAPayerUpdate(echeancesAPayer) {
  const response = await HTTP.post(URL_BASE + 'EcheancierAPayerUpdateAsync', echeancesAPayer);
  return response;
}

export async function replanificationEcheanceAPayer(echeanceInformation) {
  const response = await HTTP.post(URL_BASE + 'ReplanifierAsync', echeanceInformation);
  return response;
}

export async function getCumulEcheanceAPayer(serverTabledata) {
  const inputServer = transform(serverTabledata);
  const response = await HTTP.post(URL_BASE + 'PGetCumulEcheanceAPayerAsync', inputServer);
  return response;
}
